import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO22 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK002-2.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO22
